<template>
    <div class="activity">
        <div class="title"><p>活动运营</p></div>
        <div class="main demand">
            <div class="banner">
                <el-image :src="banner" fit="contain" lazy>
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
            <div class="step">
                <p class="service">
                    <i class="iconfont icon-kefu1"></i><span>客服电话</span>
                    <b>021-61311883</b>
                </p>
                <div class="btn">
                    <el-button type="danger" @click="subFunc" round>提 需 求</el-button>
                </div>
                <!-- <el-link type="primary">说明？</el-link> -->
            </div>
        </div>
        <div class="main activeaa" v-loading="swload">
            <h4 class="subtitle">正在火热进行中</h4>
            <el-empty v-if="allList && allList.length == 0" description="暂无活动！"></el-empty>
            <div class="swiper" v-if="allList && allList.length != 0">
                <div class="box" v-for="item in allList" :key="item.id">
                    <div class="img">
                        <el-image :src="item.image" fit="cover"></el-image>
                    </div>
                    <div class="word">
                        <div class="tit">
                            <h4>{{ item.title }}</h4>
                            <el-link type="primary">说明</el-link>
                        </div>
                        <div class="btn">
                            <span>{{ strFor(item.start_time) + " ~ " + strFor(item.end_time) }}</span>
                            <el-button type="danger" size="mini" round @click="participate(item.id)">立即参加</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="form">
                <el-form ref="form" :model="form" :inline="true">
                    <div>
                        <el-form-item label="联系人：" v-if="activeName == 'second'">
                            <el-input v-model="form.connecter" placeholder="输入联系人/联系电话" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="活动查询：" v-if="activeName == 'first'">
                            <el-input v-model="form.title" placeholder="输入活动名称/ID搜索" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="状态：">
                            <el-select v-model="form.status" placeholder="请选择" @change="changeStatus">
                                <el-option label="全部" value="0"></el-option>
                                <el-option :label="v.label" :value="v.id" v-for="(v, i) in activeName == 'first' ? atcOpt : needOpt" :key="i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时间：">
                            <el-date-picker v-model="form.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <el-button size="medium" @click="reset">重置</el-button>
                        <el-button size="medium" type="primary" @click="getApplylistFunc(1)">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main tableBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="我参与的活动" name="first"></el-tab-pane>
                <el-tab-pane label="我提交的需求" name="second"></el-tab-pane>
            </el-tabs>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tableLoad">
                    <el-table-column v-if="activeName == 'first'" prop="activity_category_id" label="ID" width="120"> </el-table-column>
                    <el-table-column v-if="activeName == 'second'" prop="connecter_name" label="联系人"> </el-table-column>
                    <el-table-column v-if="activeName == 'second'" prop="connecter_phone" label="联系电话"> </el-table-column>
                    <el-table-column prop="title" label="活动名称" v-if="activeName == 'first'"> </el-table-column>
                    <el-table-column prop="create_time" label="提交时间" sortable> </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.status | statusStr }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="option" label="操作">
                        <template slot-scope="scope">
                            <div class="option">
                                <el-link type="primary" @click="detail(scope.row)">查看详情</el-link>
                                <div v-if="activeName == 'second'" style="display: inline-block">
                                    <el-link v-if="scope.row.status == 2" type="primary" @click="prepayments(scope.row)">支付预付款</el-link>
                                    <el-link v-if="scope.row.status == 3" type="primary" @click="postMaterial(scope.row.activity_merchant_id)">上传物料</el-link>
                                    <el-link v-if="scope.row.status == 5" type="primary" @click="prepayments(scope.row)">支付尾款</el-link>
                                    <el-link v-if="scope.row.status == 1 || scope.row.status == 2" type="primary" @click="cancel(scope.row.activity_merchant_id)">取消</el-link>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageSize">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="opt"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <div class="dialog">
            <!-- 活动申请需求单 -->
            <el-dialog :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
                <span slot="title"
                    ><p>填写需求单</p>
                    <span>请选择投放的人群范围，系统会根据您的选择范围筛选合适的小区</span></span
                >
                <el-form :model="ruleForm" :rules="submitTag == 1 ? rules : rules1" ref="ruleForm" label-width="120px" class="demo-ruleForm participate" label-position="right" v-loading="formLoad">
                    <el-form-item label="联系人：" prop="connecter_name" v-if="submitTag == 1">
                        <el-input v-model="ruleForm.connecter_name" placeholder="请输入联系人" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话：" prop="connecter_phone" v-if="submitTag == 1">
                        <el-input v-model="ruleForm.connecter_phone" placeholder="请输入联系电话" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="活动地区：" prop="address">
                        <el-cascader
                            v-model="ruleForm.address"
                            :show-all-levels="false"
                            :options="addOpt"
                            :props="props"
                            collapse-tags
                            clearable
                            style="width: 100%"
                            @change="addressChange"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="投放人群：" prop="age_bracket">
                        <el-select v-model="ruleForm.age_bracket" multiple collapse-tags placeholder="请选择" style="width: 100%" @change="ageChange">
                            <el-option v-for="item in ageOpt" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="性别：" prop="gender">
                        <el-select v-model="ruleForm.gender" placeholder="请选择" style="width: 100%" multiple @change="sexChange">
                            <el-option v-for="(v, i) in sexOpt" :label="v.title" :value="v.id" :key="i"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关联商品：" prop="goods" v-if="submitTag == 1">
                        <el-button v-if="count == 0" type="primary" @click="showGoods">添加</el-button>
                        <div v-else>已添加 {{ count }} 个商品，<el-link type="primary" @click="showSelDetail">点击查看</el-link></div>
                    </el-form-item>
                    <el-form-item label="预计投放量：" prop="expected_number" v-if="submitTag == 1">
                        <el-input v-model="ruleForm.expected_number" placeholder="请输入预计投放量" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remake">
                        <el-input type="textarea" :rows="4" :placeholder="submitTag == 2 ? '请输入内容' : '您的需求补充描述（选填，如需求背景&目标；品牌/产品）'" v-model="ruleForm.remake"> </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
                    <el-button type="primary" @click="actApplyFunc(submitTag)" size="medium" :loading="btnLoad">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 详情 -->
            <el-dialog :visible.sync="detailDialogVisible" title="详情" :width="rowData.status == 4 || rowData.status == 5 || rowData.status == 6 ? '700px' : '576px'">
                <el-form label-position="left" class="detail form-detail" v-loading="detailLoad">
                    <el-form-item label="联系人" label-width="120px" v-if="activeName == 'second'">
                        <p>{{ rowData.connecter_name }}</p>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="120px" v-if="activeName == 'second'">
                        <p>{{ rowData.connecter_phone }}</p>
                    </el-form-item>
                    <el-form-item label="活动名称" label-width="120px" v-if="activeName == 'first'">
                        <p>{{ rowData.title }}</p>
                    </el-form-item>
                    <el-form-item label="活动时间" label-width="120px" v-if="activeName == 'first'">
                        <p>
                            {{ rowData.start_time + " ~ " + rowData.end_time }}
                        </p>
                    </el-form-item>

                    <el-form-item label="投放地区" label-width="120px">
                        <p>{{ rowData.region | strFmt }}</p>
                    </el-form-item>
                    <el-form-item label="年龄范围" label-width="120px">
                        <p>{{ rowData.age_bracket | strFmt }}</p>
                    </el-form-item>
                    <el-form-item label="提交时间" label-width="120px" v-if="activeName == 'first'">
                        <p>{{ rowData.create_time }}</p>
                    </el-form-item>
                    <el-form-item label="性别" label-width="120px">
                        <p>
                            {{ rowData.gender | strFmt }}
                        </p>
                    </el-form-item>
                    <el-form-item label="预计投放量" label-width="120px" v-if="activeName == 'second'">
                        <p>{{ rowData.expected_number }} 人</p>
                    </el-form-item>
                    <el-form-item label="关联商品" label-width="120px" v-if="activeName == 'second'">
                        <p>已关联 {{ rowData.good_number }} 个商品，<el-link type="primary" style="line-height: 24px" @click="showLinkGoods">点击查看</el-link></p>
                    </el-form-item>
                    <el-form-item label="备注" label-width="120px">
                        <p>{{ rowData.remarks }}</p>
                    </el-form-item>
                    <el-form-item label="状态" label-width="120px">
                        <p>{{ rowData.status | statusStr }}</p>
                    </el-form-item>
                    <div v-if="rowData.status == 4 || rowData.status == 5 || rowData.status == 6">
                        <el-form-item label="活动标题" label-width="120px">
                            <p>{{ rowData.title }}</p>
                        </el-form-item>
                        <el-form-item label="活动时间" label-width="120px">
                            <p v-if="!!rowData.start_time || !!rowData.end_time">
                                {{ rowData.start_time + " ~ " + rowData.end_time }}
                            </p>
                            <p v-else>-</p>
                        </el-form-item>
                        <el-form-item label="活动说明" label-width="120px">
                            <p>{{ rowData.rules }}</p>
                        </el-form-item>
                        <el-form-item label="活动图" label-width="120px">
                            <div class="imglistbox">
                                <div v-for="(v, i) in rowData.carousel_image" :key="i">
                                    <el-image style="width: 148px; height: 148px; border-radius: 8px" :src="v" :preview-src-list="[v]"> </el-image>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="海报图" label-width="120px">
                            <el-image style="width: 148px; height: 148px; border-radius: 8px" :src="rowData.poster_image" :preview-src-list="[rowData.poster_image]"> </el-image>
                        </el-form-item>
                    </div>
                    <el-form-item label="审核失败原因" label-width="120px" v-if="rowData.status == 8">
                        <p>{{ rowData.audit_rejection_reason }}</p>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false" size="medium">取 消</el-button>
                    <el-button type="primary" @click="detailDialogVisible = false" size="medium">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- 商品列表 -->
        <goodsList ref="goodsList" @showSpec="showSpec" @showDetail="showDetail"></goodsList>
        <!-- 商品规格 -->
        <goodsSpec ref="goodsSpec" @rowAddList="rowAddList"></goodsSpec>
        <!-- 商品详情 -->
        <goodsDetail ref="goodsDetail" @previous="previous" @postDetailData="postDetailData"></goodsDetail>
        <uploadMaterial ref="refUploadMaterial" @init="getApplylistFunc"></uploadMaterial>
        <payDialog ref="refPrepayments" @init="getApplylistFunc"></payDialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
// import address from "@/assets/address.json";
import goodsList from "./goodsList.vue";
import goodsSpec from "./goodsSpec.vue";
import goodsDetail from "./goodsDetail.vue";
import uploadMaterial from "./uploadMaterial.vue";
import payDialog from "@/components/common/payDialog.vue";
export default {
    data() {
        var checkMobile = (rule, value, cb) => {
            const regMobile = /^1[3456789]\d{9}$/;

            if (regMobile.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的手机号"));
        };
        return {
            atcOpt: [
                { id: 1, label: "待审核" },
                { id: 2, label: "已审核" },
            ],
            needOpt: [],
            banner: require("@/assets/img/activeBanner.png"),
            submitTag: null,
            activeName: "first",
            icon_list: [
                {
                    icon: require("@/assets/img/step1.png"),
                    title: "1.提交需求单",
                },
                {
                    icon: require("@/assets/img/step2.png"),
                    title: "2.等待审核",
                },
                {
                    icon: require("@/assets/img/step3.png"),
                    title: "3.支付预定金",
                },
                {
                    icon: require("@/assets/img/step4.png"),
                    title: "4.获取数据",
                },
                {
                    icon: require("@/assets/img/step5.png"),
                    title: "5.支付尾款",
                },
            ],
            formLoad: false,
            btnLoad: false,
            tableLoad: false,
            rowData: {},
            swload: false,
            isShow: false,
            allList: [],
            ruleForm: {
                connecter_name: "",
                connecter_phone: "",
                address: "",
                age_bracket: "",
                gender: "",
                goods_list: [],
                expected_number: "",
                remake: "",
            },
            age_bracketSel: [],
            genderSel: [],
            addressSel: {
                province: [],
                city: [],
            },
            rules: {
                connecter_name: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur",
                    },
                ],
                connecter_phone: [
                    {
                        required: true,
                        message: "请输入联系人电话",
                        trigger: "blur",
                    },
                    { validator: checkMobile, trigger: "blur" },
                ],
                address: [
                    {
                        required: true,
                        message: "请选择地址",
                        trigger: "change",
                    },
                ],
                age_bracket: [{ required: true, message: "请选择人群", trigger: "blur" }],
                gender: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change",
                    },
                ],
            },
            rules1: {
                address: [
                    {
                        required: true,
                        message: "请选择地址",
                        trigger: "change",
                    },
                ],
                age_bracket: [{ required: true, message: "请选择人群", trigger: "blur" }],
                gender: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change",
                    },
                ],
                remake: [{ required: true, message: "请输入备注", trigger: "blur" }],
            },
            detailDialogVisible: false,
            dialogVisible: false,
            page: 1,
            size: 10,
            total: 100,
            opt: [10, 20, 30, 40],
            form: {
                title: "",
                status: "",
                date: [],
                connecter: "",
            },

            tableData: [],
            ageOpt: [],
            addOpt: [],
            sexOpt: [],
            props: {
                multiple: true,
                label: "title",
                expandTrigger: "hover",
                value: "id",
            },
            participateId: null,
            detailLoad: false,
            count: 0,
            showLiskId: null,
            province: [],
            city: [],
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                return val
                    .toString()
                    .replace(/\[|\]|\"/g, "")
                    .replace(/\,/, "，");
            }
            return "-";
        },
        statusStr(val) {
            if (val) {
                let str = "";
                switch (Number(val)) {
                    case 1:
                        str = "待审核";
                        break;
                    case 2:
                        str = "待支付预付款";
                        break;
                    case 3:
                        str = "待上传物料";
                        break;
                    case 4:
                        str = "已上传物料";
                        break;
                    case 5:
                        str = "待支付尾款";
                        break;
                    case 6:
                        str = "已完成";
                        break;
                    case 7:
                        str = "已取消";
                        break;
                    case 8:
                        str = "审核失败";
                        break;
                    default:
                        break;
                }
                return str;
            }
            return "-";
        },
    },
    components: {
        goodsList,
        goodsSpec,
        goodsDetail,
        uploadMaterial,
        payDialog,
    },
    computed: {
        ...mapGetters(["getToken"]),
    },

    async created() {
        await this.getTagOpt();
        this.getAlllListFunc();
        this.getApplylistFunc(1);
        await this.getProcessStatus();
    },

    methods: {
        ...mapActions({
            getAllList: "commodity/getAllList",
            getApplyList: "commodity/getApplyList",
            actApply: "commodity/actApply",
            getDemandList: "commodity/getDemandList",
            postDemandApply: "commodity/postDemandApply",
            getDemandDetail: "commodity/getDemandDetail",
            demandUpdate: "commodity/demandUpdate",
            processStatus: "commodity/processStatus",
            activityGetInfo: "commodity/activityGetInfo",
            getTag: "commodity/getTag",
        }),
        async getTagOpt() {
            let res = await this.getTag();
            if (res.code == 1) {
                this.ageOpt = res.data.ageRange;
                this.sexOpt = res.data.sex;
                this.city = res.data.city;
                this.province = res.data.province;
                res.data.province.forEach((item) => {
                    item.children = [];
                    res.data.city.forEach((v) => {
                        if (v.parent == item.id) {
                            item.children.push(v);
                        }
                    });
                    this.addOpt.push(item);
                });
            }
        },
        addressChange(val) {
            let provinceId = [];
            let cityId = [];
            this.addressSel = {
                province: [],
                city: [],
            };
            val.forEach((v) => {
                provinceId.push(v[0]);
                cityId.push(v[1]);
            });
            provinceId = [...new Set(provinceId)];
            cityId = [...new Set(cityId)];
            this.province.forEach((item) => {
                let opt = {};
                provinceId.forEach((v) => {
                    if (item.id == v) {
                        opt.id = v;
                        opt.title = item.title;
                        this.addressSel.province.push(opt);
                    }
                });
            });
            this.city.forEach((item1) => {
                let opt1 = {};
                cityId.forEach((v) => {
                    if (item1.id == v) {
                        opt1.id = v;
                        opt1.title = item1.title;
                        this.addressSel.city.push(opt1);
                    }
                });
            });
            console.log(this.addressSel);
        },
        sexChange(val) {
            console.log(val);
            this.genderSel = [];
            this.sexOpt.forEach((item) => {
                val.forEach((v) => {
                    if (v == item.id) {
                        delete item.parent;
                        this.genderSel.push(item);
                    }
                });
            });
        },
        ageChange(val) {
            this.age_bracketSel = [];
            this.ageOpt.forEach((item) => {
                val.forEach((v) => {
                    if (v == item.id) {
                        delete item.parent;
                        this.age_bracketSel.push(item);
                    }
                });
            });
            console.log(this.age_bracketSel);
        },
        prepayments(row) {
            // console.log(row);
            this.$refs.refPrepayments.dialogVisible = true;
            this.$refs.refPrepayments.statusType = row.status;
            this.$refs.refPrepayments.getInfo(row.activity_merchant_id, row.order_activity_id);
        },
        postMaterial(id) {
            this.$refs.refUploadMaterial.dialogVisible = true;
            this.$refs.refUploadMaterial.id = id;
        },
        showLinkGoods() {
            this.$Bus.$emit("showLinkGoods", this.showLiskId);
        },
        // 获取活动用户名和手机号
        activityGetInfoFn() {
            this.formLoad = true;
            this.activityGetInfo({ token: this.getToken }).then((res) => {
                this.formLoad = false;
                // console.log(res);
                if (res.code == 1) {
                    this.ruleForm.connecter_phone = res.data.cellphone;
                    this.ruleForm.connecter_name = res.data.name;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 显示商品列表
        showSelDetail() {
            this.$refs.goodsDetail.dialogVisible = true;
        },
        // 状态枚举
        getProcessStatus() {
            this.processStatus({ token: this.getToken }).then((res) => {
                // needOpt
                if (res.code == 1) {
                    if (res.data.length > 0) {
                        res.data.forEach((v) => {
                            let ot = {
                                id: v.id,
                                label: v.title,
                            };
                            this.needOpt.push(ot);
                        });
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 提交需求单
        postDetailData(data) {
            this.ruleForm.goods_list = [];
            this.count = data.length;
            if (data.length > 0) {
                data.forEach((v, i) => {
                    let opt = {
                        id: v.id,
                        goods_spec_id: v.sku_id ? v.sku_id : "",
                        retail_price: v.retail_price,
                        repertory: v.repertory,
                    };
                    this.ruleForm.goods_list.push(opt);
                });
            }
        },
        // 规格选择点击确认
        rowAddList(list) {
            this.$refs.goodsList.rowAddList(list);
        },
        // 上一步
        previous() {
            this.$refs.goodsList.dialogVisible = true;
        },
        // 显示商品详情
        showDetail(list) {
            this.$refs.goodsDetail.BindData(list);
            this.$refs.goodsDetail.dialogVisible = true;
        },
        // 显示规格选择
        showSpec(row) {
            this.$refs.goodsSpec.dialogVisible = true;
            this.$refs.goodsSpec.BindData(row);
        },
        // 显示商品
        showGoods() {
            this.$refs.goodsList.dialogVisible = true;
            this.$refs.goodsList.reset();
        },
        // 关闭
        handleClose() {
            this.dialogVisible = false;
            this.$refs.goodsDetail.tableDataD = [];
            this.count = 0;
            this.$refs.ruleForm.resetFields();
            // this.ruleForm = {
            //     connecter_name: "",
            //     connecter_phone: "",
            //     address: "",
            //     age_bracket: "",
            //     gender: "",
            //     remake: "",
            // };
            this.ruleForm.address = [];
        },
        // 取消
        cancel(id) {
            console.log(id);
            this.$confirm("是否确定取消?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    try {
                        let opt = {
                            token: this.getToken,
                            activity_merchant_id: id,
                        };
                        let res = await this.demandUpdate(opt);
                        // console.log(res);
                        if (res.code != 1) {
                            return this.$message.error(res.msg);
                        }
                        this.$message.success("取消成功！");
                    } catch (err) {
                        console.log(err);
                    } finally {
                        this.getApplylistFunc();
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
        subFunc() {
            this.activityGetInfoFn();
            this.submitTag = 1;
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields();
            });
        },
        handleClick(val) {
            this.form = {
                title: "",
                status: "",
                date: [],
                connecter: "",
            };
            this.getApplylistFunc(1);
        },

        actApplyFunc(tag) {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    try {
                        this.btnLoad = true;
                        let opt = {
                            token: this.getToken,
                            gender: this.genderSel, //性别：0-不区分 1-男 2-女
                            region: this.addressSel, //地区范围 json数组
                            age_bracket: this.age_bracketSel, //年龄范围 枚举-活动-年龄范围api获取id
                            remarks: this.ruleForm.remake, //备注
                        };
                        let res;
                        if (tag == 2) {
                            opt.activity_category_id = this.participateId;
                            res = await this.actApply(opt);
                        } else {
                            opt.connecter_name = this.ruleForm.connecter_name;
                            opt.connecter_phone = this.ruleForm.connecter_phone;
                            opt.goods_list = this.ruleForm.goods_list;
                            opt.expected_number = this.ruleForm.expected_number;
                            res = await this.postDemandApply(opt);
                            this.count = 0;
                        }

                        if (res.code != 1) {
                            return this.$message.error(res.msg);
                        }
                        this.$message.success("已提交申请!");
                    } catch (err) {
                    } finally {
                        this.handleClose();
                        this.btnLoad = false;
                        this.getAlllListFunc();
                        this.getApplylistFunc(1);
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        reset() {
            this.form = {
                title: "",
                status: "",
                date: [],
            };
            this.getApplylistFunc(1);
        },

        changeStatus() {
            this.getApplylistFunc();
        },
        async getApplylistFunc(tag) {
            if (tag == 1) {
                this.page = tag;
            }
            try {
                this.tableLoad = true;
                let opt = {
                    token: this.getToken,
                    start_time: this.form.date ? this.form.date[0] : null, //提交时间范围的开始时间
                    end_time: this.form.date ? this.form.date[1] : null, //提交时间范围的结束时间
                    page_size: this.size, //页大小
                    page: this.page, //第几页
                    status: this.form.status == 0 ? null : this.form.status,
                };
                let res;
                if (this.activeName == "first") {
                    opt.title = this.form.title; //活动名称或ID
                    res = await this.getApplyList(opt);
                } else {
                    opt.text = this.form.connecter;
                    res = await this.getDemandList(opt);
                }

                if (res.code != 1) {
                    return this.$message.error(res.msg);
                }
                this.tableData = res.data.data;
                this.total = res.data.total ? res.data.total : 0;
            } catch (err) {
                console.log(err);
            } finally {
                this.tableLoad = false;
            }
        },
        async getAlllListFunc() {
            try {
                this.isShow = false;
                this.swload = true;
                let res = await this.getAllList({ token: this.getToken });
                if (res.code != 1) {
                    return this.$message.error(res.msg);
                }
                this.allList = res.data;
            } catch (err) {
                console.log(err);
            } finally {
                this.isShow = true;
                this.swload = false;
            }
        },
        participate(id) {
            this.submitTag = 2;
            this.participateId = id;
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields();
            });
        },
        async getDetailFunc(id) {
            try {
                this.showLiskId = id;
                this.detailLoad = true;
                let opt = {
                    token: this.getToken,
                    activity_merchant_id: id,
                };
                let res = await this.getDemandDetail(opt);
                // console.log(res);
                if (res.code != 1) {
                    return this.$message.error(res.msg);
                }
                return res.data[0];
            } catch (err) {
                console.log(err);
            } finally {
                this.detailLoad = false;
            }
        },
        async detail(row) {
            this.detailDialogVisible = true;
            this.rowData = JSON.parse(JSON.stringify(row));
            if (this.activeName != "first") {
                this.rowData = await this.getDetailFunc(row.activity_merchant_id);
            }
            this.rowData.region = this.rowData.region.city.map((item) => {
                return item.title;
            });
            this.rowData.age_bracket = this.rowData.age_bracket.map((item) => {
                return item.title;
            });
            this.rowData.gender = this.rowData.gender.map((item) => {
                return item.title;
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getApplylistFunc();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getApplylistFunc();
        },
        strFor(val) {
            return val.substring(0, 10);
        },
    },
};
</script>

<style lang='scss' scoped>
.activity {
    .demand.main {
        display: flex;
        justify-content: space-between;
        padding: 0;
        .banner {
            height: auto;
            // flex: 1;
            background: #eee;
            display: flex;
            justify-content: center;
            align-items: center;
            .image-slot {
                i {
                    font-size: 32px;
                }
            }
        }
        .step {
            flex: 1;
            min-width: 313px;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .btn {
                margin: 50px 0 14px;
                .el-button {
                    font-size: 16px;
                    padding: 0;
                    border: none;
                    width: 186px;
                    line-height: 48px;
                    height: 48px;
                    background: #e72f0d;
                    border-radius: 25px;
                    &:hover {
                        background: #f56c6c;
                    }
                }
            }
            .service {
                display: flex;
                align-items: center;
                i {
                    font-size: 20px;
                    color: #666;
                }
                span {
                    font-size: 14px;
                    color: #666;
                    margin: 0 12px 0 7px;
                    display: block;
                }
                b {
                    font-size: 16px;
                    color: #333;
                    transform: translateY(2px);
                }
            }
        }
    }
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        p {
            font-size: 18px;
            color: #333;
            margin-left: 0;
        }
    }
    .tableBox {
        .table {
            padding: 24px;
        }
    }
    .main {
        min-width: 1300px;
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        background: #fff;
        margin: 24px;
        padding: 24px;
        .subtitle {
            font-size: 20px;
            margin-bottom: 30px;
            font-weight: normal;
            font-weight: 500;
        }

        .swiper {
            width: 100%;
            overflow-x: scroll;
            min-height: 311px;
            display: flex;
            padding-bottom: 30px;
            &::-webkit-scrollbar-track {
                margin: 0 auto;
                // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                border-radius: 10px;
                // background-color: #f5f5f5;
            }
            &::-webkit-scrollbar {
                height: 8px;
                // background-color: #f5f5f5;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                background-color: #eee;
            }
            .box {
                &:last-child {
                    margin-right: 0;
                }
                margin-right: 32px;
                width: 272px;
                min-width: 272px;
                background: #ffffff;
                border-radius: 6px;
                border: 1px solid #d4dbff;
                .img {
                    height: 197px;
                    .el-image {
                        height: 100%;
                        width: 100%;
                        img {
                            height: 100%;
                            width: 100%;
                        }
                    }
                }
                .word {
                    padding: 12px;
                    .tit,
                    .btn {
                        display: flex;
                        justify-content: space-between;
                    }
                    .btn {
                        ::v-deep .el-button {
                            border: none;
                            background: #e72f0d;
                            &:hover {
                                background: #f56c6c;
                            }
                        }
                    }
                    .tit {
                        margin-bottom: 14px;
                        h4 {
                            width: 70%;
                            font-size: 16px;
                            color: #333;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        ::v-deep .el-link {
                            font-size: 12px;
                        }
                    }

                    p {
                        font-size: 14px;
                        color: #666;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        margin: 10px 0;
                    }
                    span {
                        font-size: 12px;
                        color: #666;
                        line-height: 28px;
                    }
                }
            }
        }
    }
    .pageSize {
        margin-top: 40px;
        text-align: right;
    }
}

.main {
    .el-form {
        display: flex;
        justify-content: space-between;
        align-items: center;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
    }
}

::v-deep .el-table th {
    background: #fafafa;
}

::v-deep .el-dialog__footer {
    border-top: 1px solid #eee;
    padding: 10px 15px !important;
}
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    span {
        display: flex;
        align-items: baseline;
        p {
            line-height: 24px;
            font-size: 16px;
            color: #333;
            margin-right: 8px;
        }
        span {
            line-height: 24px;
            font-size: 12px;
            color: #666;
        }
    }
}

.el-dialog__body {
    .el-form.participate {
        width: 85%;
        margin: 0 auto;
    }
}

.detail {
    ::v-deep .el-form-item {
        margin-bottom: 10px;
    }
}

.activeaa {
    position: relative;
    .none {
        font-size: 24px;
        color: red;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

::v-deep .el-textarea__inner {
    &::placeholder {
        font-size: 12px;
    }
}

.option {
    a {
        margin-right: 16px;
    }
}

::v-deep .el-tabs__active-bar {
    width: 140px;
}

::v-deep .el-tabs__item {
    width: 140px;
    text-align: center;
    padding: 0;
}
.form-detail {
    max-height: 500px;
    overflow-y: auto;
}
.imglistbox {
    display: flex;
    flex-wrap: wrap;
    & > div {
        height: 148px;
        width: 148px;
        margin: 0px 10px 10px 0;
    }
}
</style>